import { namespace } from 'vuex-class'
export const ModalStore = namespace('modal')

export default {
    namespaced: true,
    state: {
        activeNotification: null,
        activeModal: null,
        // cerca indirizzo o geolocalizzazione
        // lon lat
        nuoveCoordinate: null
    },
    mutations: {
        SET_ACTIVE_MODAL: (state: any, payload: any) => {
            state.activeModal = payload
            // cleans any error message when modal changes
            state.loginError = ''
            state.signupError = ''
        },
        // == Notifiche ==
        PUSH_NOTIFICATION: (state: any, payload: any) => (state.activeNotification = payload),
        REMOVE_NOTIFICATION: (state: any, payload: any) => {
            // se l evento arriva dalla notifica che viene mostrata in questo momento
            if (state.activeNotification === payload) state.activeNotification = null
        },
        // cerca indirizzo
        SET_NUOVE_COORDINATE: (state: any, payload: number[]) => {
            state.nuoveCoordinate = payload
        }
    },
    actions: {
        showModal({commit}: any, modalToShow: string) {
            commit('SET_ACTIVE_MODAL', modalToShow)
        },
        showNotification({commit}: any, dispatchParams: object) {
            commit('PUSH_NOTIFICATION', dispatchParams)
            setTimeout(() => {
                commit('REMOVE_NOTIFICATION', dispatchParams)
            }, 3500)
        }
    }
}
